var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logout-/-White",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "logout-1"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 11.004,
    x2: 23.25,
    y2: 11.004,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "19.5 14.754 23.25 11.004 19.5 7.254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75,15.5 L15.75,20 C15.785659,20.7901885 15.1760118,21.4606215 14.386,21.5 L2.113,21.5 C1.32338542,21.460091 0.714330151,20.7898174 0.75,20 L0.75,2 C0.713772541,1.20998152 1.32313205,0.539373115 2.113,0.5 L14.386,0.5 C15.1760118,0.539378461 15.785659,1.20981154 15.75,2 L15.75,6.5",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutWhite);
export default __webpack_public_path__ + "static/media/logout-white.87395a8a9e2ba0c9729151e652c684d8.svg";
export { ForwardRef as ReactComponent };